const Strings = {
  //Logo Text
  LOGO_TEXT: 'OkularID Login',

  //Error Text
  ERROR_REQUEST_TO_SERVER: 'An error occured, while sending request to server',
  CHALLENGE_NOT_MATCH: 'Challenge does not match',

  //LandingPage.js
  WELCOME_TO: 'welcome to',
  NAME: 'Name',
  EMAIL: 'Email',
  PHONENO: 'PhoneNo',
  OTP_REQUEST_SENT: 'Otp request sent to your mail successfully',
  CAMERA_NOT_AVAILABLE: 'Camera not available',

  //login
  TERMS_AND_CONDITIONS: 'Terms & Conditions |',
  PRIVACY_POLICY: 'Privacy Policy |',
  COPYRIGHTS_TEXT: 'All Rights Reserved | Copyrights - Aikaki Limited 2022',
  SIGN_IN_FOR: 'Sign in for',
  SCAN_YOUR_QR: 'Scan your QR here',
  EMAIL_ADDRESS: 'Email Address',
  OKULARID_SHARES:
    'OkularID will shares verified email and phone number with the ',
  PROVIDE_YOUR_CONSENT: 'Please provide your consent for the same.',
  SIGN_IN: 'Sign In',
  SCAN_QR_CODE: 'Scan above QR code to login',

  //Logout.js
  SUCCESSFULLY_LOGOUT: 'Successfully logout from OkularID Login',

  //register.js
  REGISTER_SUCCESSFULLY: 'Register successfull , redirecting you to login page',
  FULL_NAME: 'Full Name',
  USERNAME: 'Username',
  PHONE_NUMBER: 'Phone Number',
  LOADING: 'Loading ....',
  REGISTER: 'Register',
};
export { Strings };
